module.exports = __webpack_public_path__ + "static/elephant7-334b5fb7612d0d776a6e06cdc882a644.jpeg";